// highlightPhrases.ts
export function highlightPhrases(text: string): string {
  const repeatedPhrases = ['We commit', 'We are committed', 'To extend', 'To create', 'To provide', 'To deliver', 'To equip', 'To build'];
  let newText = text;
  
  repeatedPhrases.forEach((phrase) => {
    const regex = new RegExp(phrase, 'gi'); // 'gi' = global + case-insensitive
    newText = newText.replace(
    regex,
    (match) => `<span class="fancy-font" style="font-weight: bold;">${match}</span>`
    );
  });
  
  return newText;
}
